import { BulletListContent } from './bullet-list-content.component.js';
export { BulletListContent } from './bullet-list-content.component.js';
import { BulletListIcon } from './bullet-list-icon.component.js';
export { BulletListIcon } from './bullet-list-icon.component.js';
import { BulletList } from './bullet-list.component.js';
export { BulletList } from './bullet-list.component.js';
import { ListItem } from './list-item.component.js';
export { ListItem } from './list-item.component.js';
import { List } from './list.component.js';
export { List } from './list.component.js';
import { OrderedList } from './ordered-list.component.js';
export { OrderedList } from './ordered-list.component.js';
import { deprecatedComponent } from '../core/deprecated-component.js';

const IconBulletList = deprecatedComponent({
    displayName: 'IconBulletList',
    root: BulletList,
    description: 'Use BulletList instead'
});
const IconBulletListIcon = deprecatedComponent({
    displayName: 'IconBulletListIcon',
    root: BulletListIcon,
    description: 'Use BulletListIcon instead'
});
const IconBulletListItem = deprecatedComponent({
    displayName: 'IconBulletListItem',
    root: BulletListContent,
    description: 'Use BulletListContent instead'
});
const Ul = List;
const Ol = OrderedList;
const Li = ListItem;

export { IconBulletList, IconBulletListIcon, IconBulletListItem, Li, Ol, Ul };
